import { ApiFetch } from '../../../shared/utils/fetch';
import { unwrap, type Enveloped } from '../../../shared/utils/unwrap';
import type { Settlement } from '../types';

export const settlementsApi = {
  // TCS-staff path: read any merchant's settlements by id. Backend guards this
  // COLLECTIVE-only — a merchant-scoped caller gets 403 here (use listOwn instead).
  listByMerchant: async (tenantId: string): Promise<Settlement[]> => {
    const response = await ApiFetch.get<Enveloped<Settlement[]>>(`/settlements/merchant/${tenantId}`);
    return unwrap(response);
  },
  // Merchant-scoped path: the caller's OWN settlements, tenant derived from the JWT
  // (no id in the URL). Backend guards this MERCHANT-only. Same underlying
  // payment-service settlements endpoint as listByMerchant → identical Settlement[].
  listOwn: async (): Promise<Settlement[]> => {
    const response = await ApiFetch.get<Enveloped<Settlement[]>>('/merchants/me/payouts');
    return unwrap(response);
  },
};
